// eslint-disable-next-line
import util from 'util';

// eslint-disable-next-line
import * as PortalApi from '../PortalApi';

export function getPhoneToken(successHandler, errorHandler) { 
  PortalApi.call('/api/me/twilioToken', {},
                 successHandler, errorHandler);
}

export function getOutcallPin(successHandler, errorHandler,
                              phoneNumberId, outcallNumber) {
  let form = PortalApi.makeForm({phoneNumberId, outcallNumber});
  util.log(form);
  PortalApi.call('/api/me/outcallRequest', { method: 'post', body: form },
                 successHandler, errorHandler);
}
